// extracted by mini-css-extract-plugin
module.exports = {"brandsList":"BrandsUnderline_brandsList__d5q08","brandsListUnderline":"BrandsUnderline_brandsListUnderline__81mRu"};